import VipUpgradePanel from '@/components/tupian/detail/vip-upgrade-panel';
import DetailFormatPanel from '@/components/tupian/detail/detail-format-panel'
import TupianMask from '@/components/tupian/tupian-mask'
import DetailEquity from '@/components/tupian/detail/detail-equity'
import RelevancePic from '@/components/tupian/detail/relevance-pic'

let panelExtend = {
  components:{
    VipUpgradePanel,
    DetailFormatPanel,
    TupianMask,
    DetailEquity,
    RelevancePic
  },
  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {
      }
    },
  },

  filters: {
    disposeLayoutName(val) {
      if (Array.isArray(val)) {
        return val.join(' / ')
      } else {
        return val;
      }
    }
  }
}

export default panelExtend;
